import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-interveniente',
  templateUrl: './auth-interveniente.component.html',
  styleUrls: ['./auth-interveniente.component.scss']
})
export class AuthIntervenienteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
